export { type Grapheme, graphemeTable } from "#grapheme-table";
